import { Injectable, inject } from '@angular/core';
import { WebsocketTokens } from '@buspro/shared/common';
import { AppWebSocketsService, IWebsocketService } from '@buspro/web/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlatformOverviewStats } from './admin-dashboard-api.service';

@Injectable({ providedIn: 'root' })
export class AdminDashboardWebsocketService implements IWebsocketService<PlatformOverviewStats> {
  eventName: WebsocketTokens = WebsocketTokens.ADMIN_DASHBOARD_PLATFORM_OVERVIEW;

  private socket: AppWebSocketsService = inject(AppWebSocketsService);
  private logger = inject(NGXLogger);

  /**
   * Emit request for platform overview stats
   */
  emit(): void {
    this.emitWith(null);
  }

  /**
   * Emit request with optional data
   */
  emitWith(data: unknown): void {
    this.socket.emit(this.eventName, data);
  }

  /**
   * Listen for platform overview updates
   */
  listen(): Observable<PlatformOverviewStats> {
    return this.socket.listen<PlatformOverviewStats>(this.eventName).pipe(
      map((data: PlatformOverviewStats) => {
        this.logger.debug('Received platform overview update:', data);
        return data;
      }),
    );
  }

  /**
   * Listen for completed trips updates specifically
   */
  listenCompletedTrips(): Observable<PlatformOverviewStats['completedTrips']> {
    return this.socket
      .listen<PlatformOverviewStats['completedTrips']>(WebsocketTokens.ADMIN_DASHBOARD_COMPLETED_TRIPS)
      .pipe(
        map((data) => {
          this.logger.debug('Received completed trips update:', data);
          return data;
        }),
      );
  }

  /**
   * Listen for general stats updates
   */
  listenStatsUpdate(): Observable<PlatformOverviewStats> {
    return this.socket.listen<PlatformOverviewStats>(WebsocketTokens.ADMIN_DASHBOARD_STATS_UPDATE).pipe(
      map((data) => {
        this.logger.debug('Received stats update:', data);
        return data;
      }),
    );
  }
}
